import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { ClienteDetalharRoutingModule } from "./cliente-detalhar-routing.module";
import { ClienteDetalharComponent } from "./cliente-detalhar.component";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";

@NgModule({
    imports: [
        CommonModule,
        ClienteDetalharRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        InputMaskModule,
        ProgressSpinnerModule,
        MessagesModule,
        FormatPipeModule

    ],
    declarations: [ClienteDetalharComponent]
})
export class ClienteDetalharModule { }
